/**
 * 운영자가 고른 색 팔레트를 화면에 적용 — `:root` CSS 변수를 덮어쓴다.
 *
 * base.css 에 기본 색이 이미 있으므로 **못 받아도 화면은 정상**이다(불변식 3).
 * 그래서 실패를 조용히 삼켜도 되는 의도된 경계다 — 여기서 throw 하면 앱이 안 뜬다.
 *
 * 색 자체는 고를 수 없다. shared `PALETTES` 중 하나를 고를 뿐이고,
 * 그 팔레트들은 전부 대비 검사를 통과한 것이다(`palette.test.ts`).
 */
import { paletteById, paletteCssVars } from "@greg-chick/shared";
import { loadSiteText } from "./siteTextApi";

export async function applyPalette(): Promise<void> {
  const text = await loadSiteText();
  const vars = paletteCssVars(paletteById(text.theme));
  for (const [name, value] of Object.entries(vars)) {
    document.documentElement.style.setProperty(name, value);
  }
}
